export default __webpack_public_path__ + "static/media/autumn.05296e37.png";